import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { getFirstPathFromPathname } from 'lib/request';

import LINKS from 'constants/links';

const DefaultNavigation = dynamic(() => import('./DefaultNavigation'));
const CouponsNavigation = dynamic(() => import('./CouponsNavigation'));
const ForumNavigation = dynamic(() => import('./ForumNavigation'));

const NAVS_BY_PAGE = {
  [LINKS.COUPONS]: CouponsNavigation,
  [LINKS.FORUM]: ForumNavigation,
  DEFAULT: DefaultNavigation,
};

const Navigation = ({ gaEventCategory }) => {
  const { pathname } = useRouter();

  const firstPath = getFirstPathFromPathname(pathname);
  const NavComponent = NAVS_BY_PAGE[firstPath] ?? NAVS_BY_PAGE.DEFAULT;

  return <NavComponent gaEventCategory={gaEventCategory} />;
};

Navigation.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default Navigation;
